module.exports = __webpack_public_path__ + "static/media/error.5dfbf993.jpg";